import { jsx as _jsx } from "react/jsx-runtime";
import toast from "react-hot-toast";
import { Toast } from "@parkschannel/ui";
export const errorToast = (props)=>{
    return toast.custom((t)=>{
        /*#__PURE__*/ return _jsx(Toast.ErrorToast, {
            title: props === null || props === void 0 ? void 0 : props.title,
            description: props === null || props === void 0 ? void 0 : props.description,
            ...t
        });
    }, props === null || props === void 0 ? void 0 : props.options);
};
export const successToast = (props)=>{
    return toast.custom((t)=>{
        /*#__PURE__*/ return _jsx(Toast.SuccessToast, {
            title: props === null || props === void 0 ? void 0 : props.title,
            description: props === null || props === void 0 ? void 0 : props.description,
            ...t
        });
    }, props === null || props === void 0 ? void 0 : props.options);
};
export const infoToast = (props)=>{
    return toast.custom((t)=>{
        /*#__PURE__*/ return _jsx(Toast.InfoToast, {
            title: props === null || props === void 0 ? void 0 : props.title,
            description: props === null || props === void 0 ? void 0 : props.description,
            ...t
        });
    }, props === null || props === void 0 ? void 0 : props.options);
};
